import React from "react";
import textConfig from "../utils/text";

/**
 * Frame 17
 * @param props
 * @constructor
 */
export default function Frame17(props: any) {
	
	let {  Svg, svgProps, children, viewBox, frameBody } = props;
	let { path, text_1 } = props, [ __html, { textColor, style } ] = textConfig(text_1, frameBody);
	
	return <Svg xmlns="http://www.w3.org/2000/svg" {...svgProps} viewBox="0 0 1121.206 1832.215">
		<rect
			width="1091" height="1210"
			transform="translate(15 255)"
			fill={'none'}
			stroke={frameBody}
			strokeWidth={30}
		/>
		<g transform={"translate(61 352)"}>
			{children}
		</g>
		<g>
			<path
				d="M957.127,561.681H164.079A164.079,164.079,0,0,1,0,397.6V178.83H441.646a21.878,21.878,0,0,0,16.408-5.469l94.345-71.1a17.775,17.775,0,0,1,16.408,0l94.345,71.1a21.878,21.878,0,0,0,16.408,5.469h441.646V397.6A164.079,164.079,0,0,1,957.127,561.681Z"
				transform="translate(0 1270.534)" fill={frameBody}/>
			<path
				d="M1121.206,273.465H0V164.079A164.079,164.079,0,0,1,164.079,0H957.127a164.079,164.079,0,0,1,164.079,164.079Z"
				fill={frameBody}/>
			<rect width="273" height="27" rx="10" transform="translate(424 123)" fill={textColor}/>
		</g>
		<g transform={"translate(61 1535) scale(1)"}>
			<svg xmlns="http://www.w3.org/2000/svg" width={1000} height={200} viewBox={viewBox}>
				<defs>
					<clipPath id="myClip">
						<path d={path}/>
					</clipPath>
				</defs>
				<foreignObject x="0" y="0" width="1000" height="200" clipPath="url(#myClip)">
					<div
						dangerouslySetInnerHTML={{__html}}
						style={{
							width: 'calc(100%)', height: 'calc(100%)',
							display: 'flex', justifyContent: 'center', alignItems: 'center',
							...style, color: textColor
						}}
					/>
				</foreignObject>
			</svg>
		</g>
	</Svg>
}